import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@npm-registry/eapteka-ui';
import { text } from '../../../text';
import { PromocodeForm } from './Form';
import { PromocodeInformer } from './Informer';
import { Skeleton } from './Skeleton';
import { selectAppliedStatus } from '../../../store/promocode';
import { selectLoading } from '../../../store/summary';
import styles from './Promocode.scss';

export const Promocode = () => {
  const appliedStatus = useSelector(selectAppliedStatus);
  const loading = useSelector(selectLoading);
  const isPending = loading === 'idle';
  const isPromocodeApplied = appliedStatus === 'applied';
  const isPromocodeFormVisible =
    !isPending && !isPromocodeApplied;

  return (
    <div className={styles.root}>
      <Typography className={styles.title} weight="strong">
        {text['promocode.title']}
      </Typography>

      {isPending && <Skeleton />}
      {isPromocodeApplied && <PromocodeInformer />}
      {isPromocodeFormVisible && <PromocodeForm />}
    </div>
  );
};
